import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { getIngredientAmountString, buildSourceURL } from '../../utils/functions';
import { getDishes, deleteDish, makeDishesAudit } from '../../actions/dish';
import styles from './Dishes.module.css';

const Dishes = (props) => {
  const { 
    getDishes, 
    deleteDish, 
    dishesData, 
    makeDishesAudit
  } = props;

  const [selectedMeal, setSelectedMeal] = useState('');
  const [filteredDishes, setFilteredDishes] = useState(dishesData);
  const [highFat, setHighFat] = useState(false);
  const [goodProtein, setGoodProtein] = useState(false);

  useEffect(() => {
    getDishes();
  }, []);

  useEffect(() => {
    let filteredDishesData;
    if (selectedMeal) {
      filteredDishesData = dishesData.filter(dish => dish.meal_name === selectedMeal);
    } else {
      filteredDishesData = dishesData;
    }

    if (highFat) {
      // debugger;
      filteredDishesData = filteredDishesData.filter(dish => dish.high_fat);
    }

    if (goodProtein) {
      filteredDishesData = filteredDishesData.filter(dish => dish.high_protein);
    }

    setFilteredDishes(filteredDishesData);
  }, [selectedMeal, dishesData, highFat, goodProtein]);

  const deleteHandler = (id) => {
    const confirmResult = window.confirm('Are you sure?');

    if (confirmResult) {
      deleteDish(id);
    }
  };

  const renderComponentName = (dishComponents, componentName) => {
    if (dishComponents.length === 1) {
      return null;
    }

    return (
      <div className={styles.componentName}>
        {componentName}:
      </div>
    );
  };

  const renderIngredientsList = (dishComponents) => {
    return dishComponents.map((component, index) => {

      return (
        <div key={index} className={styles.ingredientsBlock}>
          {renderComponentName(dishComponents, component.name)}
          {component.ingredients.map(ingredient => (
            <div key={ingredient.id} className={styles.ingredientItem}>
              {getIngredientAmountString(ingredient, ingredient.amount, ingredient.is_required)}
            </div>
          ))}
        </div>
      );
    });
  };

  const renderInstructions = (dishComponents, serving) => {
    const instructions = dishComponents.map((component, index) => (
      <div key={index} className={styles.instructionItem}>
        {renderComponentName(dishComponents, component.name)}
        {component.instruction}
      </div>
    ));

    if (serving) {
      instructions.push(
        <div key="serving" className={styles.instructionItem}>
          <div className={styles.componentName}>
            Serving:
          </div>
          {serving}
        </div>
      );
    }

    return instructions;
  };

  const dishFilterHandler = ({ target }) => {
    setSelectedMeal(target.value);
  };

  const calculateHandler = () => {
    const confirmResult = window.confirm('Are you sure?');

    if (confirmResult) {
      makeDishesAudit();
    }
  };

  const renderImage = (dishData) => {
    if (dishData.image) {
      return (
        <img className={styles.dishImage} src={buildSourceURL(dishData.image)} />
      );
    }
  };

  const renderVideoLinkBuild = (dishData) => {
    if (dishData.video) {
      return (
        <a 
          className={styles.videoLink}
          target="_blank" 
          rel="noreferrer" 
          href={`/video?video=${dishData.video}`}
        >
          ▶️
        </a>
      );
    }
  };

  const renderExcludedMeals = (excludedMeals) => {
  if (excludedMeals?.length) {
    return (
      <div>
        {excludedMeals.map((excludedMeal, index) => (
          <div className={styles.excludedMealRow} key={index}>
            {excludedMeal.meal}
          </div>
        ))}
      </div>
    );
  }
};

  const renderAudit = (dishData) => {
    return (
      <div>
        {!!dishData.high_fat && <div className={styles.highFat}>High Fat ({dishData.high_fat}%)</div>}
        {!!dishData.high_protein && <div className={styles.highProtein}>Good Protein ({dishData.high_protein}%)</div>}
      </div>
    );
  };

  return (
    <div className="wrapper">
      <h1>
        Dishes
      </h1>
      <div className={styles.tools}>
        <div className={styles.tools}>
          <select 
            className={styles.dishTypeSelect} 
            onChange={dishFilterHandler}
            value={selectedMeal}
          >
            <option value="">All</option>
            <option value="breakfast">Breakfast</option>
            <option value="snack">Snack</option>
            <option value="lunch">Lunch</option>
            <option value="dinner">Dinner</option>
          </select>
          <label className={cn(styles.checkbox)}>
            <span>High fat</span>
            <input  
              checked={highFat}
              onChange={({ target }) => setHighFat(target.checked)}
              type="checkbox"
            />
          </label>
          <label className={styles.checkbox}>
            <span>Good protein</span>
            <input  
              checked={goodProtein}
              onChange={({ target }) => setGoodProtein(target.checked)}
              type="checkbox"
            />
          </label>
          <span className={styles.results}>Results: {filteredDishes.length}</span>
        </div>
        <div className={styles.tools}>
          <div className={styles.calculate} onClick={calculateHandler}>
            Calculate fat & protein
          </div>
          <a className={styles.addDish} href="/add-dish">
            Add dish
          </a>
        </div>
      </div>
      <table className={cn(styles.table, 'table')}>
        <thead>
        <tr>
          <th>Image</th>
          <th>Name</th>
          <th>Meal Name</th>
          <th>Instructions</th>
          <th>Ingredients</th>
          <th>Excluded meals</th>
          <th>Audit</th>
          <th>Video</th>
          <th>Controls</th>
        </tr>
        </thead>
        <tbody>
        {filteredDishes?.map((dishData) => (
          <tr key={dishData.id}>
            <td>
              {renderImage(dishData)}
            </td>
            <td>                
              {dishData.name}
            </td>
            <td>
              {dishData.meal_name}<br /><br />
            </td>
            <td>
              {renderInstructions(dishData.components, dishData.serving)}
            </td>
            <td>
              {renderIngredientsList(dishData.components)}
            </td>
            <td>
              {renderExcludedMeals(dishData.excluded_meals)}
            </td>
            <td>
              {renderAudit(dishData)}
            </td>
            <td>
              {renderVideoLinkBuild(dishData)}
            </td>
            <td className="controls">
              <Link to={`/edit-dish/${dishData.id}`} className="button green-button">
                Edit
              </Link>
              <button className="button red-button" onClick={() => deleteHandler(dishData.id)}>
                Delete
              </button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (store) => ({
  dishesData: store.dish.dishesData,
});

const mapDispatchToProps = {
  getDishes,
  deleteDish,
  makeDishesAudit,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dishes);